import { createAction } from '@reduxjs/toolkit';
import { LastState } from './model';

export const saveRequested = createAction<void, 'al/lastState/saveRequested'>(
  'al/lastState/saveRequested',
);

export const saved = createAction<{ id: LastState['id'] }, 'al/lastState/saved'>(
  'al/lastState/saved',
);

export const applied = createAction<LastState | undefined, 'al/lastState/applied'>(
  'al/lastState/applied',
);

export const popState = createAction<
  { url: string; state_id: number | null },
  'al/lastState/popState'
>('al/lastState/popState');
